import { formatDistanceToNow } from 'date-fns';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isDateValid,
  prepareNotificationMessage,
} from '../../../utils';
import { CHAT_NOTIFICATION_TYPES } from '../../../utils/constant';
import {
  makeReadNotificationsAsync
} from '../../store/slices/common/notificationsSlice';
import Avatar from '../Common/Avatar/Avatar';
import { getLocale } from '../../../utils/cityUtils';

const Notifications = ({ setOpen = () => {} }) => {
  const lang = useSelector(({ common }) => common?.language);
  const dispatch = useDispatch();
  const router = useRouter();
  const { city } = router?.query;
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const topNotifications = useSelector(
    ({ notifications }) => notifications?.topNotifications
  );
  const unreadCount = useSelector(
    ({ notifications }) => notifications?.unreadCount
  );

  const selectedCity = useSelector(({ cities }) => cities?.selectedCity);

  const makeReadNotification = (notification) => {
    if (!notification.read_at) {
      dispatch(makeReadNotificationsAsync({ id: notification.id, is_top: 1 }));
      // dispatch(getTopNotificationsAsync());
    }
    setUnreadNotificationCount((count) => (count > 1 ? count-- : 0));
    if (
      notification?.notification_type === 'citywriter_application' ||
      notification?.notification_type === 'citywriter_approve_application'
    ) {
      window.open(notification.url);
    } else if (notification?.url) {
      setOpen(false);
      router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${notification.url}`
      );
    }
  };

  const handleSeeAllNotifications = () => {
    // setOpen({ ...open, notification: false });
    setOpen(false);
  };

  useEffect(() => {
    topNotifications?.forEach((notification) => {
      if (!notification.read_at)
        setUnreadNotificationCount((count) => count + 1);
    });
  }, []);

  return (
    <div className='relative h-[590px] w-full md:w-[400px]'>
      <h3 className='px-[8px] py-[16px] text-[22px] font-bold sm:border-b sm:border-[#F6F6F6]'>
        {lang?.common?.notifications}{' '}
        {unreadCount > 0 && `(${unreadCount} ${lang?.common?.new})`}
      </h3>
      {topNotifications && topNotifications.length ? (
        <div className='flex flex-col justify-between'>
          <div className=' overflow-y-auto'>
            {topNotifications
              .filter(
                (item) =>
                  !CHAT_NOTIFICATION_TYPES.includes(item?.notification_type)
              )
              .slice(0, 5)
              .map((notification, index) => (
                <div
                  key={index}
                  role='button'
                  onClick={() => makeReadNotification(notification)}
                  className={`flex gap-2 px-[12px] py-2 ${
                    notification?.read_at
                      ? 'bg-white hover:bg-gray-200'
                      : 'bg-[#F6F6F6] hover:bg-gray-200'
                  }`}
                >
                  <div className='flex items-center gap-[8px]'>
                    {/* {!notification?.read_at ? (
                      <div className='h-[8px] w-[8px] rounded-full bg-[#EB5757] '></div>
                    ) : (
                      <div className='h-[8px] w-[8px] rounded-full '></div>
                    )} */}
                    <Avatar
                      userName={notification?.from}
                      imagePath={notification?.avatar?.path || ''}
                      height={'h-[48px]'}
                      width={'w-[48px]'}
                    />
                  </div>
                  <div className='ml-1 w-[250px] sm:w-[300px]'>
                    <p className='line-clamp-2 text-[14px]'>
                      {prepareNotificationMessage(
                        lang,
                        notification?.language_msg
                      )}
                    </p>
                    <p className='mt-[8px] text-[12px] text-[#808080]'>
                      {isDateValid(notification?.notification_time) &&
                        formatDistanceToNow(
                          new Date(notification?.notification_time),
                          {
                            addSuffix: true,
                            locale: getLocale(selectedCity?.id),
                          }
                        )}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <Link
            href={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/notifications?city=${city}`}
            className='  absolute bottom-0 flex w-full items-center justify-center border-t border-[#F6F6F6] bg-white py-[16px]'
          >
            <button
              onClick={handleSeeAllNotifications}
              className='btn-outlined'
            >
              {lang?.common?.see_all_notifications}
            </button>
          </Link>
        </div>
      ) : (
        <h5 className='text-muted mb-5 mt-3 text-center'>
          {lang?.common?.no_notifications_found}
        </h5>
      )}
    </div>
  );
};

export default Notifications;
